module.exports = __webpack_public_path__ + "static/media/tutorial-banner.d7418fe1.png";